module.exports = __webpack_public_path__ + "static/media/male4.9a35ae04.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/male4.png
// module id = 897
// module chunks = 0